export default __webpack_public_path__ + "static/media/laguna1.45fb7144.jpg";